<template>
  <div class="tabbarPage" ref="tabbarPage">
    <div class="my_tabbar flex-between">
      <div
        class="my_tabba_item"
        v-for="(item, index) in tabList"
        :key="index + 'a'"
        :class="{ active: tabbarActive == index }"
        @click.prevent="handleNavBar(index, item.path)"
        ref="myTabbaItems"
      >
        {{ item.txt }}
        <div class="dropdown_menu" v-if="index == 1 && isShow">
          <div
            class="dropdown_item flex-rowc"
            @click.stop="handleGo('/parkFlash/pList')" 
            :class="{ active: tabbarItemActive == 0 }"
            v-if="deptObj.role == 1 && deptObj.ispao == 1"
          >
            跑腿业务跟进
          </div>
          <div
            class="dropdown_item flex-rowc"
            @click.stop="handleGo('/orderMineList')"
            :class="{ active: tabbarItemActive == 1 }"
            v-if="deptObj.isdu == 1"
          >
            送餐业务跟进
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "tabbar",
  data() {
    return {
      // tabList: ["业务", "", "订单列表", "客服管理", "我的"],
      tabList: [
        { txt: "业务", path: "/home" },
        { txt: "订单跟进", path: "" },
        // { txt: "订单列表", path: "/orderList" },
        { txt: "客服管理", path: "/serviceMange" },
        { txt: "我的", path: "/mine" },
      ],
      tabbarActive: 0,
      tabbarItemActive: 0,
      userInfo: "",
      isShow: false,
      deptObj: ''
    };
  },
  computed: {
    ...mapState(["USERINFO"]),
  },
  created() {
    this.deptObj = this.USERINFO.dept ? this.USERINFO.dept[0] : {};
    this.$watch(() => {
      if (this.$route.path == "/mine") {
        this.tabbarActive = 3;
      } else if (this.$route.path == "/home") {
        this.tabbarActive = 0;
      } else if (
        this.$route.path == "/orderMineList" ||
        this.$route.path == "/parkFlash/pOrderList"
      ) {
        this.tabbarActive = 1;
      } else if (this.$route.path == "/orderList") {
        this.tabbarActive = 2;
      } else if (this.$route.path == "/serviceMange") {
        this.tabbarActive = 2;
      }
      if (this.$route.path == "/orderMineList") {
        this.tabbarItemActive = 1;
      } else if (this.$route.path == "/parkFlash/pOrderList") {
        this.tabbarItemActive = 0;
      }
    });
  },
  mounted() {
    // 在组件挂载后添加全局点击事件监听
    document.addEventListener('click', this.handleGlobalClick);
  },
  beforeDestroy() {
    // 在组件销毁前移除全局点击事件监听
    document.removeEventListener('click', this.handleGlobalClick);
  },
  methods: {
    handleGo(url) {
      this.isShow = false;
      if (url == this.$route.path) return;
      this.$router.push(url);
    },
    handleNavBar(index, path) {
      if (this.$route.path == path) return;
      this.tabbarActive = index;
      if (path == "") {
        this.isShow = !this.isShow;
      } else {
        this.$router.push(path);
        this.isShow = false;
      }
    },
    handleGlobalClick(event) {
      const tabbarPage = this.$refs.tabbarPage;
      const myTabbaItems = this.$refs.myTabbaItems;
      if (!tabbarPage || !myTabbaItems) return;

      // 检查点击位置是否在 my_tabba_item 内部
      const isInsideTabbaItem = Array.from(myTabbaItems).some(item => 
        item.contains(event.target)
      );

      if (!isInsideTabbaItem && this.isShow) {
        this.isShow = false;
      }
    }
  },
};
</script>

<style lang='less' scoped>
.tabbarPage {
  width: 750px;
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  height: 150px;
  font-size: 24px;
  color: #000000;
  border-top: 1px solid #c9c9c9;
  background: #fff;
  z-index: 1000001;
  .my_tabbar {
    height: 100%;
    .my_tabba_item {
      border-right: 1px solid #c9c9c9;
      text-align: center;
      height: 100%;
      line-height: 150px;
      flex: 1;
      position: relative;
      &:last-child {
        border-right: none;
      }
      &.active {
        color: #eb1b3d;
      }
      .dropdown_menu {
        position: absolute;
        left: -35px;
        right: -35px;
        bottom: 150px;
        background: #fff;
        box-shadow: 0 -15px 20px 2px rgba(0, 0, 0, 0.1);
        box-sizing: border-box;
        font-size: 24px;
        color: #000000;
        padding: 0 10px;
        .dropdown_item {
          height: 120px;
          &:last-child {
            border-top: 1px solid #ccc;
          }
          &.active {
            color: #eb1b3d;
          }
        }
      }
    }
  }
}
</style>